/** What the picker needs of a catalogue entry — the built-in list and an active version both fit. */
export interface CatalogueCode {
  code: string;
  description: string;
}

export interface TargetOption {
  code: string;
  /** Null for a value the catalogue does not list. */
  description: string | null;
}

/**
 * The options the target picker shows. A value already stored but missing from the catalogue stays
 * selectable: the catalogue is a curated selection, and the server accepts codes it does not list.
 */
export function buildTargetOptions(
  catalogue: readonly CatalogueCode[],
  currentValue: string,
): TargetOption[] {
  const options: TargetOption[] = catalogue.map((entry) => ({
    code: entry.code,
    description: entry.description,
  }));

  const stored = currentValue.trim();
  if (stored === '' || options.some((option) => option.code === stored)) {
    return options;
  }

  // First, so an unlisted value is visible without scrolling a long catalogue.
  return [{ code: stored, description: null }, ...options];
}
